import { TagDTO, TagEntity } from '@gearbelt/global';
import { ColumnHelper } from '@tanstack/react-table';

import { ApiService } from '@/services/api-v2';

import { TagBadges } from './tag-badges';

export const ASSET_SECTION_LABEL = 'Asset';

export const getAssetTagFilterOptions = async () => {
  const response = await (await ApiService.GetTags({ limit: 500, filters: { fields: { entity: TagEntity.Asset } } })).json();
  return response.data.map((tag) => ({
    label: tag.tag,
    value: tag.id,
  }));
};

export const assetTagsColumnOptions = {
  header: 'Asset Tags',
  enableGrouping: false,
  enableSorting: false,
  enableColumnFilter: true,
  meta: {
    filterType: 'async-multi-select',
    getFilterOptionsFn: getAssetTagFilterOptions,
    columnGroup: ASSET_SECTION_LABEL,
  },
} as const;

export function createAssetTagsColumn<T extends { asset?: { tags?: TagDTO[] | null } | null }>(columnHelper: ColumnHelper<T>) {
  return columnHelper.accessor((row) => row.asset?.tags, {
    id: 'assetTags',
    ...assetTagsColumnOptions,
    cell: ({ getValue }) => <TagBadges tags={getValue()} />,
  });
}
